<div class="ap">
    <conversational-link (changeConversationalStatus$)="setStatusChangeSubscriptions($event)">> </conversational-link>
    <conversational-chat-container>
        @if (showError()) {
            <ap-error class="ap-padding-3 ap-text-align-center chat-background-color" [apError]="takeoverError()"></ap-error>
        } @else if (showConnector()) {
            <klant-conversational-connector class="ap-flex ap-flex-column ap-flex-1 chat-background-color">
            </klant-conversational-connector>
        }
    </conversational-chat-container>
</div>
